<template>
  <div class="operate">
    <div v-if="type == 'create'" class="operate-btn" @click="handleCreateClick">
      <span>去创建人群</span>
    </div>
    <template v-else>
      <div class="operate-sure" @click="handleSureClick">
        <span>确认生成人群</span>
      </div>
    </template>
    <select-group
      v-if="visible"
      v-model="visible"
      :item="item"
      @comfirm="handleConfirm"
    />
    <edit-group
      v-if="editVisible"
      v-model="editVisible"
      :tabList="tabList"
      @comfirm="handleEditComfirm"
    />
  </div>
</template>

<script>
import selectGroup from "./selectGroup.vue";
import editGroup from "./editGroup.vue";

export default {
  props: {
    type: {
      type: String,
      default: "create",
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    selectGroup,
    editGroup,
  },
  computed: {
    tabList() {
      if (this.item.packs) {
        return this.item.packs.map((item) => {
          return {
            name: item.crowdName,
            crowdNo: item.crowdNo,
            editData: {
              id: item.crowdNo,
              name: item.crowdName,
              description: item.crowdDescription,
              classifyId: item.crowdCategory,
              strategy: JSON.stringify(item.payload.strategy),
            },
          };
        });
      } else {
        return [];
      }
    },
  },
  created() {
    if (this.type == "edit" && !this.item.agentBiDataJson) {
      this.handleSureClick();
    }
  },
  data() {
    return {
      visible: false,
      editVisible: false,
    };
  },
  methods: {
    handleCreateClick() {
      this.visible = true;
    },
    handleConfirm(val) {
      this.$emit("comfirm", val);
    },
    handleEditComfirm(val) {
      const packs = val.map((item) => {
        return {
          crowdNo: item.crowdNo,
          crowdName: item.name,
          crowdCategory: item.params.crowdCategory
            ? item.params.crowdCategory
            : null,
          crowdDescription: item.params.crowdDescription,
          payload: {
            strategy: item.params.strategy,
          },
        };
      });
      this.$emit("sure", packs);
    },
    handleSureClick() {
      this.editVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.operate {
  padding-bottom: 10px;
  margin-top: 20px;
  &-btn {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid #3159ff;
    cursor: pointer;
    font-size: 12px;
    padding: 0px 12px;
    color: #3159ff;
    display: inline-block;
  }
  &-sure {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #3159ff;
    border-radius: 20px;
    cursor: pointer;
    font-size: 12px;
    padding: 0px 12px;
    color: #fff;
    display: inline-block;
  }
}
.margin-l8 {
  margin-left: 8px;
}
</style>